const TableFilterButton = ({ handleFilterStatusToggle }) => {
  return (
    <button onClick={handleFilterStatusToggle} className="btn btn-sm buttons-collection btn-label-secondary  me-2">
      <span>
        <span className="d-flex align-items-center gap-2">
          <i className="icon-base ti tabler-filter icon-xs" />
          {/* <span className="d-none d-sm-inline-block"> */}
          <span className="">Filter</span>
        </span>
      </span>
    </button>
  );
};

export default TableFilterButton;
